import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MetaTags } from '../models';
import { AppStateService } from './app-state.service';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  meta = inject(Meta);
  title = inject(Title);
  appStateService = inject(AppStateService);

  setTitle(title: string) {
    this.title.setTitle(`${this.appStateService.businessInfo.name} | ${title}`);
  }

  getTitle(): string {
    return this.title.getTitle();
  }

  private addMetaTagsOG(tags: MetaTags) {
    // For OpenGraph - Facebook
    this.meta.addTags([
      { name: 'og:title', content: tags.titleOG },
      { name: 'og:description', content: tags.descriptionOG },
      { name: 'og:image', content: tags.imageOG || `${this.appStateService.businessInfo.websiteUrl}/images/logos/logo.png` },
      { name: 'og:url', content: tags.urlOG },
      { name: 'og:type', content: tags.typeOG || 'website' }
    ]);
  }

  addSeoTags(tags: MetaTags) {
    this.meta.addTags([
      { name: 'description', content: tags.description }
    ]);

    this.addMetaTagsOG(tags);
  }
}
